import axios from 'axios'
import { API_ADDRESS } from 'config'
import { ScrapeHistoryItem } from 'state/types'

export const getScrapeHistory = async (page, limit, types, statuses): Promise<ScrapeHistoryItem[]> => {
  const typesString = types.toString()
  const statusesString = statuses.toString()
  const url = `${API_ADDRESS}/admin/scrape-history/list?page=${page}&limit=${limit}&types=${typesString}&statuses=${statusesString}`
  const { data } = await axios.get(url)

  return data
}
